export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.845f2f0d.worker.js");
}
